import { ROLES } from "@/config/roles";
import MainLayout from "@/layouts/MainLayout";
import SsoCallback from "@/pages/auth/SsoCallback";
import RemunDosenDetailPage from "@/pages/common/remun-dosen/RemunDosenDetailPage";
import RemunDosenPage from "@/pages/common/remun-dosen/RemunDosenPage";
import ValidasiJabatanPage from "@/pages/admin/validasi-jabatan/ValidasiJabatanPage";
import LoginPage from "@/pages/auth/LoginPage";
import BackLoginPage from "@/pages/auth/BackLoginPage";
import RekapRemunPage from "@/pages/common/rekap-remun/RekapRemunPage";

import DosenDashboardPage from "@/pages/dosen/dashboard/DosenDashboardPage";
import DashboardPage from "@/pages/admin/dashboard/DashboardPage";
import DistributionPage from "@/pages/admin/dashboard/DistributionPage";
import ClusterIkuPage from "@/pages/admin/dashboard/ClusterIkuPage";
import Analytics70TablePage from "@/pages/admin/dashboard/Analytics70TablePage";
import PeriodeClusterPage from "@/pages/admin/manajemen-periode/cluster/PeriodeClusterPage";
import BesaranSerdosPage from "@/pages/admin/manajemen-periode/besaran-serdos/BesaranSerdosPage";
import PeriodeGradePage from "@/pages/admin/manajemen-periode/grade/PeriodeGradePage";
import PeriodeKomponenPage from "@/pages/admin/manajemen-periode/komponen/PeriodeKomponenPage";
import PeriodeNilaiMaxUnsurPage from "@/pages/admin/manajemen-periode/nilai-max-unsur/PeriodeNilaiMaxUnsurPage";
import PeriodeKelasPage from "@/pages/admin/manajemen-periode/kelas/PeriodeKelasPage";
import MasterDataDosenPage from "@/pages/admin/master-data/dosen/MasterDataDosenPage";
import MasterDataGrade from "@/pages/admin/master-data/grade/MasterDataGrade";
import MasterDataKomponenKegiatan from "@/pages/admin/master-data/komponen-kegiatan/MasterDataKomponenKegiatan";
import MasterDataUnitKerjaPage from "@/pages/admin/master-data/unitkerja/MasterDataUnitKerjaPage";
import MasterDataUsersPage from "@/pages/admin/master-data/users/MasterDataUsersPage";
import PertanyaanMasukanPage from "@/pages/admin/PertanyaanMasukanPage";
import ProtectedRoute from "@/routes/ProtectedRoute";
import { createBrowserRouter } from "react-router";
import ErrorPage from "@/pages/error/ErrorPage";
import NotFoundPage from "@/pages/error/NotFoundPage";
import SsoCallbackPage from "@/pages/auth/SsoCallback";
import LogAktivitasPage from "@/pages/admin/settings/logs/LogAktivitasPage";

import { Navigate } from "react-router";
import { useAuth } from "@/hooks/use-auth";
import { ROLE_REDIRECT_MAP } from "@/config/roles";

function RootRedirect() {
  const { user } = useAuth();
  if (!user || !user.role) return <Navigate to="/" replace />;
  const targetPath =
    ROLE_REDIRECT_MAP[user.role as keyof typeof ROLE_REDIRECT_MAP] || "/";
  return <Navigate to={targetPath} replace />;
}

export const router = createBrowserRouter([
  {
    path: "/sso-callback",
    Component: SsoCallback,
  },
  {
    path: "/login",
    Component: LoginPage,
  },
  {
    path: "/back-login",
    Component: BackLoginPage,
  },
  {
    path: "/sso/callback",
    Component: SsoCallbackPage,
    errorElement: <ErrorPage />,
  },
  {
    element: <ProtectedRoute />,
    children: [
      {
        path: "/",
        Component: MainLayout,
        children: [
          {
            index: true,
            Component: RootRedirect,
          },
          {
            path: "admin",
            element: (
              <ProtectedRoute
                allowedRoles={[
                  ROLES.ADMIN_SUPER,
                  ROLES.ADMIN_UNIV,
                  ROLES.ADMIN_KEPEGAWAIAN,
                  ROLES.ADMIN_HTL,
                  ROLES.ADMIN_FAKULTAS,
                ]}
              />
            ),
            children: [
              {
                path: "dashboard",
                Component: DashboardPage,
              },
              {
                path: "dashboard/sebaran-sks",
                Component: DistributionPage,
              },
              {
                path: "dashboard/cluster-iku",
                Component: ClusterIkuPage,
              },
              {
                path: "dashboard/analytics-70-table",
                Component: Analytics70TablePage,
              },
              {
                path: "remun-dosen",
                Component: RemunDosenPage,
              },
              {
                path: "remun-dosen/:niu",
                Component: RemunDosenDetailPage,
              },
              {
                path: "rekap-remun",
                Component: RekapRemunPage,
              },
              {
                path: "validasi-jabatan",
                Component: ValidasiJabatanPage,
              },
              {
                element: (
                  <ProtectedRoute
                    allowedRoles={[ROLES.ADMIN_SUPER, ROLES.ADMIN_UNIV]}
                  />
                ),
                children: [
                  {
                    path: "pertanyaan",
                    Component: PertanyaanMasukanPage,
                  },
                ],
              },
              {
                element: <ProtectedRoute allowedRoles={[ROLES.ADMIN_SUPER]} />,
                children: [
                  {
                    path: "periode/komponen",
                    Component: PeriodeKomponenPage,
                  },
                  {
                    path: "periode/grade",
                    Component: PeriodeGradePage,
                  },
                  {
                    path: "periode/nilai-max-unsur",
                    Component: PeriodeNilaiMaxUnsurPage,
                  },
                  {
                    path: "periode/cluster",
                    Component: PeriodeClusterPage,
                  },
                  {
                    path: "periode/besaran-serdos",
                    Component: BesaranSerdosPage,
                  },
                  {
                    path: "periode/kelas",
                    Component: PeriodeKelasPage,
                  },
                  {
                    path: "master/dosen",
                    Component: MasterDataDosenPage,
                  },
                  {
                    path: "master/komponen-kegiatan",
                    Component: MasterDataKomponenKegiatan,
                  },
                  {
                    path: "master/unit-kerja",
                    Component: MasterDataUnitKerjaPage,
                  },
                  {
                    path: "master/grade",
                    Component: MasterDataGrade,
                  },
                  {
                    path: "master/users",
                    Component: MasterDataUsersPage,
                  },
                ],
              },
            ],
          },
          {
            path: "settings",
            element: <ProtectedRoute allowedRoles={[ROLES.ADMIN_SUPER]} />,
            children: [
              {
                path: "logs",
                Component: LogAktivitasPage,
              },
            ],
          },
          {
            path: "dosen",
            element: <ProtectedRoute allowedRoles={[ROLES.DOSEN]} />,
            children: [
              {
                path: "dashboard",
                Component: DosenDashboardPage,
              },
              {
                path: "remunerasi",
                Component: RemunDosenDetailPage,
              },
            ],
          },
        ],
      },
      {
        path: "*",
        Component: NotFoundPage,
      },
    ],
  },
]);
